import { useTranslation } from 'react-i18next'
import { User } from 'graphqlAPI'
import { prefixColumns } from './constants'
import BasePopover from 'components/monitoring/components/BasePopover'
import { Col, Row } from 'react-bootstrap'

export function CoursesCount({ value }: { value: User | undefined }) {
  const { t } = useTranslation()

  const total = (value?.coursesCount || 0) + (value?.externalCoursesCount || 0)
  return (
    <BasePopover
      id={'courses_count-' + value?.id}
      popoverContent={
        <Row>
          <Col xs={12}>
            {t('monitoring.courses.title')}:&nbsp;{value?.coursesCount || 0}
          </Col>
          <Col xs={12}>
            {t('monitoring.externalCourses.title')}:&nbsp;
            {value?.externalCoursesCount}
          </Col>
        </Row>
      }
    >
      <span>
        {t(`${prefixColumns}.courses`, {
          count: total,
        })}
      </span>
    </BasePopover>
  )
}
